import { DesignPosition } from "@kamae-apps/shared/Components/DesignStates/DesignPosition"
import { IconNames } from "@kamae-apps/shared/Components/Fondations/Icons/IconNames.type"
import clsx from "clsx"
import { FC } from "react"
import Icon from "../../Fondations/Icons/Icon"
import style from "./Link.module.css"

type LinkVariants =
  | "link-default-initial"
  | "link-default-black"
  | "link-default-disable"
  | "link-small-initial"
  | "link-small-black"
  | "link-small-disable"

type LinkStatus = "initial" | "black" | "disable"
type LinkSize = "default" | "small"
type VariantProps = {
  status: LinkStatus
  size: LinkSize
}

const linkVariantToProps: Record<LinkVariants, VariantProps> = Object.freeze({
  "link-default-initial": { status: "initial", size: "default" },
  "link-default-black": { status: "black", size: "default" },
  "link-default-disable": { status: "disable", size: "default" },
  "link-small-initial": { status: "initial", size: "small" },
  "link-small-black": { status: "black", size: "small" },
  "link-small-disable": { status: "disable", size: "small" },
})

type LinkProps = {
  variant: LinkVariants
  title: string
  onClick?: () => void
  iconName?: IconNames
  iconPosition?: DesignPosition
}
export const Link: FC<LinkProps> = ({ variant, title, onClick, iconName = "plus", iconPosition = "none" }) => {
  const { status, size } = linkVariantToProps[variant]

  return (
    <div
      className={clsx(style["link-container"], style[`link-color-${status}`])}
      onClick={onClick}
      data-testid={"link"}
    >
      {iconPosition === "left" && <LinkIcon iconName={iconName} />}
      <span className={clsx(style[`link-${status}`], style[`link-${size}`])}>{title}</span>
      {iconPosition === "right" && <LinkIcon iconName={iconName} />}
    </div>
  )
}

const LinkIcon = ({ iconName }: { iconName: IconNames }) => {
  return (
    <Icon
      size={"xs"}
      name={iconName}
    />
  )
}
